import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../../schema.dexie";
import { listarAtividades } from "../queries";
import { STATUS_ATIVIDADE_LABEL, type StatusAtividade } from "../types";
import { AtividadeFoto } from "../ui/AtividadeFoto";
import { StatusAtividadeBadge } from "../ui/StatusAtividadeBadge";
import { IndicadorParticipacao } from "../ui/IndicadorParticipacao";

type Filtro = "todas" | StatusAtividade;

const FILTROS: { v: Filtro; r: string }[] = [
  { v: "todas", r: "todas" },
  { v: "favorita", r: "favoritas" },
  { v: "em_exploracao", r: "em exploração" },
  { v: "sensivel", r: "sensíveis" },
  { v: "nao_usada", r: "não usadas" },
];

const FILTROS_VALIDOS = new Set<Filtro>(FILTROS.map((f) => f.v));

export function BibliotecaCorpo() {
  const nav = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const param = searchParams.get("status") as Filtro | null;
  const filtro: Filtro = param && FILTROS_VALIDOS.has(param) ? param : "todas";
  const setFiltro = (f: Filtro) =>
    setSearchParams(f === "todas" ? {} : { status: f }, { replace: true });

  const atividades = useLiveQuery(() => listarAtividades()) ?? [];
  const momentos = useLiveQuery(() => db.momento_psm.toArray()) ?? [];

  const lista =
    filtro === "todas" ? atividades : atividades.filter((a) => a.status === filtro);

  return (
    <main className="tela">
      <button className="btn btn-fantasma" onClick={() => nav(-1)}>
        ← voltar
      </button>
      <div className="row-entre">
        <h1 className="tela-titulo">biblioteca</h1>
        <Link to="/gingado/biblioteca/nova" className="btn btn-primario">
          ➕ nova
        </Link>
      </div>

      <div className="chips" style={{ marginBottom: "var(--s4)" }}>
        {FILTROS.map((f) => (
          <button
            key={f.v}
            className="chip"
            style={
              filtro === f.v
                ? {
                    background: "var(--accent-suave-bg)",
                    color: "var(--accent-forte)",
                    borderColor: "var(--accent-suave-borda)",
                  }
                : undefined
            }
            onClick={() => setFiltro(f.v)}
          >
            {f.r}
          </button>
        ))}
      </div>

      {lista.length === 0 ? (
        <div className="vazio">
          <span className="emoji" aria-hidden>
            🤸
          </span>
          {atividades.length === 0
            ? "nenhuma atividade ainda. comece cadastrando uma."
            : "nada neste filtro."}
        </div>
      ) : (
        <div className="lista-cards">
        {lista.map((a) => (
          <button
            className="card linha-alimento"
            key={a.id}
            onClick={() => nav(`/gingado/atividade/${a.id}`)}
          >
            <AtividadeFoto midias={a.midias} nome={a.nome} tipo={a.tipo} />
            <div className="crescer">
              <div className="row-entre">
                <div className="nome">{a.nome}</div>
                <StatusAtividadeBadge status={a.status} />
              </div>
              <div className="meta">{STATUS_ATIVIDADE_LABEL[a.status]}</div>
              <IndicadorParticipacao atividadeId={a.id} momentos={momentos} />
            </div>
          </button>
        ))}
        </div>
      )}
    </main>
  );
}
